"use client";

import "@/core/services/service-bootstrap";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";

export default function ReactQueryProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						gcTime: 1000 * 60 * 5, // 5 minutes, old cacheTime
						refetchOnMount: true,
						refetchOnReconnect: true,
						refetchOnWindowFocus: true,
						retry: 1, // Retry failed requests once
					},
				},
			}),
	);

	return (
		<QueryClientProvider client={queryClient}>
			{children}
			<ReactQueryDevtools />
		</QueryClientProvider>
	);
}
